import { CONTACT, DOCTOR, AREAS } from "@/data/site";

const origin = () =>
  process.env.REACT_APP_SITE_URL ||
  (typeof window !== "undefined" ? window.location.origin : "");

export const buildLocalBusinessSchema = () => ({
  "@context": "https://schema.org",
  "@type": "Dentist",
  "@id": `${origin()}/#clinic`,
  name: CONTACT.name,
  alternateName: CONTACT.clinic,
  image: `${origin()}/logo512.png`,
  logo: `${origin()}/logo512.png`,
  url: origin(),
  telephone: CONTACT.phoneTel.replace("tel:", ""),
  email: CONTACT.email,
  address: {
    "@type": "PostalAddress",
    streetAddress: CONTACT.address,
    addressLocality: "Varanasi",
    addressRegion: "Uttar Pradesh",
    postalCode: "221007",
    addressCountry: "IN",
  },
  hasMap: CONTACT.gmbUrl,
  sameAs: [CONTACT.gmbUrl],
  openingHoursSpecification: [
    {
      "@type": "OpeningHoursSpecification",
      dayOfWeek: ["Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"],
      opens: "10:00",
      closes: "20:00",
    },
    {
      "@type": "OpeningHoursSpecification",
      dayOfWeek: "Sunday",
      opens: "10:00",
      closes: "14:00",
    },
  ],
  ...(CONTACT.rating
    ? {
        aggregateRating: {
          "@type": "AggregateRating",
          ratingValue: CONTACT.rating.value,
          reviewCount: CONTACT.rating.count,
          bestRating: "5",
          worstRating: "1",
        },
      }
    : {}),
  priceRange: "$$",
  medicalSpecialty: "Dentistry",
  areaServed: AREAS.map((a) => ({ "@type": "Place", name: `${a}, Varanasi` })),
});

export const buildPersonSchema = () => ({
  "@context": "https://schema.org",
  "@type": "Physician",
  name: CONTACT.name,
  jobTitle: DOCTOR.role,
  image: `${origin()}/images/doctor.webp`,
  worksFor: {
    "@type": "MedicalClinic",
    name: CONTACT.clinic,
  },
  medicalSpecialty: "Dentistry",
  url: `${origin()}/dr-ankesh-seth`,
});

export const buildServiceSchema = (t, performerName) => ({
  "@context": "https://schema.org",
  "@type": "MedicalProcedure",
  name: t.name,
  description: t.overview || t.short,
  url: `${origin()}/${t.slug}`,
  performer: { "@type": "Physician", name: performerName || CONTACT.name },
  location: {
    "@type": "MedicalClinic",
    name: CONTACT.clinic,
    address: CONTACT.address,
  },
});

export const buildFaqSchema = (faqs) => ({
  "@context": "https://schema.org",
  "@type": "FAQPage",
  mainEntity: faqs.map((f) => ({
    "@type": "Question",
    name: f.q,
    acceptedAnswer: { "@type": "Answer", text: f.a },
  })),
});

export const buildBreadcrumbSchema = (items) => ({
  "@context": "https://schema.org",
  "@type": "BreadcrumbList",
  itemListElement: items.map((it, i) => ({
    "@type": "ListItem",
    position: i + 1,
    name: it.name,
    item: `${origin()}${it.path}`,
  })),
});

export const buildBlogPostingSchema = (post) => ({
  "@context": "https://schema.org",
  "@type": "BlogPosting",
  headline: post.title,
  description: post.metaDescription,
  image: post.image,
  datePublished: post.date,
  dateModified: post.date,
  mainEntityOfPage: { "@type": "WebPage", "@id": `${origin()}/blog/${post.slug}` },
  author: {
    "@type": "Person",
    name: CONTACT.name,
    url: `${origin()}/dr-ankesh-seth`,
  },
  publisher: {
    "@type": "Organization",
    name: CONTACT.clinic,
    logo: { "@type": "ImageObject", url: `${origin()}/logo512.png` },
  },
  keywords: post.keyword,
});
